import { StickyNote, Link2, Image as ImageIcon, FileText } from "lucide-react";

const PARTS = [
  ["notes", "note", "notes", StickyNote],
  ["links", "link", "links", Link2],
  ["photos", "photo", "photos", ImageIcon],
  ["files", "file", "files", FileText],
];

// "What's inside": 12 notes · 5 links · 8 photos · 2 files (counted at publish time).
export const WhatsInside = ({ p }) => {
  const c = p.contents;
  const parts = c ? PARTS.filter(([k]) => c[k] > 0) : [];
  if (!parts.length) return null;
  return (
    <div data-testid={`whats-inside-${p.product_id}`} className="flex flex-wrap items-center gap-x-2 gap-y-1 text-[11px] text-[#9CA3AF]" aria-label="What's inside">
      {parts.map(([k, one, many, Icon], i) => (
        <span key={k} className="flex items-center gap-1">
          {i > 0 && <span className="text-[#3F3F46] mr-1">·</span>}
          <Icon className="h-3 w-3 text-[#60A5FA]" />
          <b className="text-[#D1D5DB] font-medium tabular-nums">{c[k]}</b> {c[k] === 1 ? one : many}
        </span>
      ))}
    </div>
  );
};
